import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

/**
 * Componente de superposición (overlay) que muestra mensajes con ícono y, de
 * forma opcional, botones de confirmación o un botón para recargar la aplicación.
 */
@Component({
  selector: 'app-overlay',
  templateUrl: './overlay.component.html',
  styleUrls: ['./overlay.component.css']
})
export class OverlayComponent implements OnInit {
  @Input() icono: string = '';
  @Input() mensaje: string = '';
  @Input() buttons: boolean = false;
  @Input() reload: boolean = false;
  @Output() onDeleteLote = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {
  }

  /**
   * Emite el evento de confirmación o cancelación de la acción del overlay.
   * @param cancelar - Cadena que indica si la acción fue cancelada; vacía cuando se confirma.
   */
  outputDeleteLote( cancelar: string = '') {
    this.onDeleteLote.emit(cancelar)
  }

  /**
   * Recarga la página actual del navegador.
   */
  reloadApp() {
    window.location.reload();
  }
}
